// src/i18n.js
import { createI18n } from "vue-i18n";

import EN from "./langs/en-US.json";
import NL from "./langs/nl-BE.json";
import FR from "./langs/fr-BE.json";

const messages = {
	en: {
		...EN
	},
	fr: {
		...FR
	},
	NL: {
		...NL
	}
};

const i18n = createI18n({
	legacy: false, // you must specify 'legacy: false' to use Composition API
	locale: "en", // set locale
	fallbackLocale: "en", // set fallback locale
	messages // set locale messages
});

export default i18n;
